import React, { useEffect, Fragment } from "react";
import { styled } from '@mui/material/styles';
import Checkbox from "@mui/material/Checkbox";
import { IconButton } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import { setHazard } from "../../../actions/filters";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import earthquakeIcon from "../../../../assets/images/earthquake.png";
import floodIcon from "../../../../assets/images/flood.png";
import hurricaneIcon from "../../../../assets/images/hurricane.png";
import tsunamiIcon from "../../../../assets/images/tsunami.png";
import HtmlTooltip from "./HtmlTooltip";
import InfoIcon from "@mui/icons-material/Info";


const PREFIX = 'Hazard';

const classes = {
  root: `${PREFIX}-root`,
  infoIcon: `${PREFIX}-infoIcon`,
  title: `${PREFIX}-title`,
  option: `${PREFIX}-option`,
  imageContainer: `${PREFIX}-imageContainer`,
  image: `${PREFIX}-image`,
  name: `${PREFIX}-name`,
  remove: `${PREFIX}-remove`,
  header: `${PREFIX}-header`,
  bold: `${PREFIX}-bold`,
};

const Root = styled('div')((
  {
    theme
  }
) => ({

  [`& .${classes.infoIcon}`]: {
    color: '#0078a9',
    fontSize: '0.9rem',
    margin: '0 0.25rem'
    },

  [`& .${classes.title}`]: {
    color: "#4c4c4c",
    fontSize: "0.9rem",
    margin: "0 0 0.5em 0",
    textTransform: "uppercase",
  },

  [`& .${classes.option}`]: {
    display: "flex",
    alignItems: "center",
  },

  [`& .${classes.imageContainer}`]: {
    width: "3em",
    display: "flex",
    justifyContent: "center",
  },

  [`& .${classes.image}`]: {
    height: "1.5em",
  },

  [`& .${classes.name}`]: {
    textTransform: "capitalize",
  },

  [`& .${classes.remove}`]: {
    background: "#999999",
    borderRadius: "50%",
    padding: "0em",
    color: "#fff",
    position: "absolute",
    right: "0.5em",
    top: "0.5em",
    "&:hover": {
      background: "#909090",
      boxShadow:
        "0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.1rem",
    },
  },

  [`& .${classes.header}`]: {
    display: "flex",
    textAlign: "center",
    width: "max-content",
    "&:hover": {
      cursor: "pointer",
    },
  },

  [`& .${classes.bold}`]: {
    fontWeight: "bold",
  },

}));

const options = [
  {
    name: "earthquake",
    icon: earthquakeIcon,
  },
  {
    name: "flood",
    icon: floodIcon,
  },
  {
    name: "hurricane",
    icon: hurricaneIcon,
  },
  {
    name: "tsunami",
    icon: tsunamiIcon,
  },
];

const Hazard = ({ setHazard, hazard }) => {

  const TooltipText = () => {
    return (
      <Fragment>
        <h3>Hazard</h3>
        <p>
          Includes only hazard types that are checked. If none are checked, it
          will include all hazard types.
        </p>
      </Fragment>
    );
  };

  const handleChange = (event) => {
    setHazard({ ...hazard, [event.target.name]: event.target.checked });
  };

  const remove = () => {
    setHazard({
      earthquake: false,
      flood: false,
      hurricane: false,
      tsunami: false,
    });
  };

  useEffect(() => {}, [hazard]);

  return (
    <Root className={classes.root}
	sx={{
		border: "1px solid #e9e9e9",
	    borderRadius: "5px",
	    width: "16em",
	    padding: "1em",
	    position: "relative",
	    margin: "1em 0",
	    background: "#fff",
	}}>
      <HtmlTooltip
        disableFocusListener
        disableTouchListener
        title={<TooltipText />}
        placement="top"
      >
        <div className={classes.header}>
          <div className={classes.title}>Hazard</div>
          <InfoIcon className={classes.infoIcon} />
        </div>
      </HtmlTooltip>
      <IconButton
        className={classes.remove}
        onClick={remove}
        alt="clear"
        aria-label="clear hazard filter"
      >
        <RemoveIcon />
      </IconButton>
      {options.map((option) => {
        return (
          <div className={classes.option}>
            <Checkbox
              aria-label={`filter results by ${hazard[option.name]}`}
              checked={hazard[option.name]}
              onChange={handleChange}
              name={option.name}
            />
            <div className={classes.imageContainer}>
              <img
                src={option.icon}
                alt={option.name}
                className={classes.image}
              />
            </div>
            <span className={classes.name}>{option.name}</span>
          </div>
        );
      })}
    </Root>
  );
};

Hazard.propTypes = {
  setHazard: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  hazard: state.filters.hazard,
});

export default connect(mapStateToProps, { setHazard })(Hazard);
